import classNames from 'classnames';

import Verified from '../icons/Verified';
import './VerificationIconWrapper.scss';

const VerificationIconWrapper = ({ children, className = '' }) => {
  const classes = classNames('verification-icon-wrapper', className);
  return (
    <div className={classes}>
      <span className="verification-icon-wrapper__verifier">{children}</span>
      <span className="verification-icon-wrapper__icon">
        <Verified />
      </span>
    </div>
  );
};

export default VerificationIconWrapper;
